export const calculateBoundsAndCenter = (coordinates, marginFactor = 0.05) => {
  if (!coordinates?.length) {
    return {
      bounds: undefined,
      center: undefined,
    };
  }

  const { minLat, maxLat, minLng, maxLng } = coordinates.reduce(
    (acc, [lat, lng]) => ({
      minLat: Math.min(acc.minLat, lat),
      maxLat: Math.max(acc.maxLat, lat),
      minLng: Math.min(acc.minLng, lng),
      maxLng: Math.max(acc.maxLng, lng),
    }),
    {
      minLat: Infinity,
      maxLat: -Infinity,
      minLng: Infinity,
      maxLng: -Infinity,
    }
  );

  // Calculate the margin
  const latMargin = (maxLat - minLat) * marginFactor;
  const lngMargin = (maxLng - minLng) * marginFactor;

  // Expand the bounds
  const expandedMinLat = minLat - latMargin;
  const expandedMaxLat = maxLat + latMargin;
  const expandedMinLng = minLng - lngMargin;
  const expandedMaxLng = maxLng + lngMargin;

  return {
    bounds: [
      [expandedMaxLat, expandedMaxLng],
      [expandedMinLat, expandedMinLng],
    ],
    center: [(minLat + maxLat) / 2, (minLng + maxLng) / 2],
  };
};
